import { render, staticRenderFns } from "./DistrictEdit.vue?vue&type=template&id=fad87c0e&scoped=true&"
import script from "./DistrictEdit.vue?vue&type=script&lang=js&"
export * from "./DistrictEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad87c0e",
  null
  
)

export default component.exports